var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Price.FullContainerFreightDetails"),
        width: "960px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        top: "5vh",
        "custom-class": "details-view fcl-form"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticStyle: { "margin-bottom": "10px" } },
          [
            _c(
              "el-button",
              {
                attrs: { no: "onSubmit", type: "success" },
                on: { click: _vm.onSubmit }
              },
              [_vm._v(_vm._s(_vm.$t("Pricing.Save")))]
            ),
            _c(
              "el-button",
              {
                attrs: { no: "onCancel", type: "success" },
                on: { click: _vm.onCancel }
              },
              [_vm._v(_vm._s(_vm.$t("Pricing.Cancel")))]
            )
          ],
          1
        ),
        _c("div", { staticStyle: { width: "fit-content" } }, [
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.PriceNo") } },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "priceNo",
                            value: _vm.price.priceNo,
                            disabled: true
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "freightType",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.PriceType")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            disabled: _vm.disabledFreightType,
                            no: "freightType",
                            "static-options": _vm.priceTypes,
                            "tag-value": "code",
                            "default-value": _vm.price.freightType,
                            clearable: false
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.freightType = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "pol",
                        attrs: { required: "", label: _vm.$t("Pricing.POL") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "pol",
                            "static-options": _vm.seaPortList,
                            "custom-label": function(item) {
                              return "[" + item.code + "]" + item.englishName
                            },
                            "filter-tag-names": ["code", "englishName"],
                            "show-custom-label-in-option": true,
                            "tag-value": "code",
                            "default-value": _vm.price.pol,
                            filterable: ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.pol = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "pod",
                        attrs: { required: "", label: _vm.$t("Pricing.POD") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "pod",
                            "static-options": _vm.seaPortList,
                            "custom-label": function(item) {
                              return "[" + item.code + "]" + item.englishName
                            },
                            "filter-tag-names": ["code", "englishName"],
                            "show-custom-label-in-option": true,
                            "tag-value": "code",
                            "default-value": _vm.price.pod,
                            filterable: ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.pod = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: " " } },
                      [
                        _c("el-checkbox", {
                          attrs: {
                            no: "direct",
                            label: _vm.$t("Pricing.Direct")
                          },
                          model: {
                            value: _vm.price.direct,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "direct", $$v)
                            },
                            expression: "price.direct"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: " " } },
                      [
                        _c("el-checkbox", {
                          attrs: {
                            no: "checkSaleState",
                            label: _vm.$t("Pricing.SpecialPrice")
                          },
                          model: {
                            value: _vm.checkSaleState,
                            callback: function($$v) {
                              _vm.checkSaleState = $$v
                            },
                            expression: "checkSaleState"
                          }
                        })
                      ],
                      1
                    ),
                    !_vm.price.direct
                      ? _c(
                          "el-form-item",
                          {
                            ref: "via",
                            attrs: {
                              required: true,
                              label: _vm.$t("Pricing.Via")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "via",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Seaport,
                                "custom-label": function(item) {
                                  return (
                                    "[" + item.code + "]" + item.englishName
                                  )
                                },
                                "filter-tag-names": ["code", "englishName"],
                                "show-custom-label-in-option": true,
                                "default-value": _vm.price.via,
                                filterable: ""
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.price.via = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      {
                        ref: "term",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.PaymentTerm")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "term",
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_PriceConstant$PAYMENT_TERMS,
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.term
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.term = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "carrier",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.Carrier")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "carrier",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": { seaCmp: true, active: true },
                            "custom-label": function(item) {
                              return (
                                "[" + item.shortName + "]" + item.chineseName
                              )
                            },
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.carrier
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.carrier = p.cmpIdx
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "vessel",
                        attrs: { label: _vm.$t("SeaExport.Vessel") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "vessel",
                            "select-type":
                              _vm.selectTypeNames.static_data_Vessel,
                            filterable: "",
                            "allow-create": true,
                            "static-options": _vm.vesselList,
                            "default-value": _vm.price.vessel
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.onVesselSelectionChange(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "voyageFlight",
                        attrs: { label: _vm.$t("SeaExport.Voyage") }
                      },
                      [
                        _c("cargo-advance-select", {
                          ref: "voyageFlight",
                          attrs: {
                            no: "6",
                            "static-options": _vm.voyages || [],
                            cache: false,
                            "default-value": _vm.price.voyageFlight,
                            filterable: "",
                            clearable: "",
                            "allow-create": true,
                            "tag-name": "voyageNo",
                            "tag-value": "voyageNo",
                            "filter-tag-names": ["voyageNo"]
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.voyageFlight = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.ShippingLine") } },
                      [
                        _c("el-input", {
                          attrs: { no: "shippingLine", maxlength: 16 },
                          model: {
                            value: _vm.price.shippingLine,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "shippingLine", $$v)
                            },
                            expression: "price.shippingLine"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.ContractNo") } },
                      [
                        _c("el-input", {
                          attrs: { no: "contractNo", maxlength: 32 },
                          model: {
                            value: _vm.price.contractNo,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "contractNo", $$v)
                            },
                            expression: "price.contractNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Lane") } },
                      [
                        _c("el-input", {
                          attrs: { no: "lane", maxlength: 64 },
                          model: {
                            value: _vm.price.lane,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "lane", $$v)
                            },
                            expression: "price.lane"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "bookingAgent",
                        attrs: { required: "", label: _vm.$t("Pricing.Source") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "bookingAgent",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": {
                              bookingAgent: true,
                              active: true
                            },
                            "custom-label": function(item) {
                              return "" + item.chineseName
                            },
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.bookingAgent
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.bookingAgent = p.cmpIdx
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.TransportMode") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "transportMode",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_ShippingTerm,
                            placeholder: _vm.$t("Pricing.PlsSelect"),
                            "default-value": _vm.price.transportMode,
                            "tag-value": "name"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.transportMode = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.SubContractNo") } },
                      [
                        _c("el-input", {
                          attrs: { no: "subContractNo", maxlength: 32 },
                          model: {
                            value: _vm.price.subContractNo,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "subContractNo", $$v)
                            },
                            expression: "price.subContractNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.NA") } },
                      [
                        _c("el-input", {
                          attrs: { no: "na", maxlength: 32 },
                          model: {
                            value: _vm.price.na,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "na", $$v)
                            },
                            expression: "price.na"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.NaCode") } },
                      [
                        _c("el-input", {
                          attrs: { no: "naCode", maxlength: 32 },
                          model: {
                            value: _vm.price.naCode,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "naCode", $$v)
                            },
                            expression: "price.naCode"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.COST_VAT") } },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { no: "costVat", type: "number" },
                              on: {
                                change: _vm.costVatChange,
                                focus: _vm.checkCost
                              },
                              model: {
                                value: _vm.costVat,
                                callback: function($$v) {
                                  _vm.costVat = $$v
                                },
                                expression: "costVat"
                              }
                            }),
                            _c("label", [_vm._v(" %")])
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.SELL_VAT") } },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { no: "sellVat", type: "number" },
                              on: {
                                change: _vm.sellVatChange,
                                focus: _vm.checkSell
                              },
                              model: {
                                value: _vm.sellVat,
                                callback: function($$v) {
                                  _vm.sellVat = $$v
                                },
                                expression: "sellVat"
                              }
                            }),
                            _c("label", [_vm._v(" %")])
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Dock") } },
                      [
                        _c("el-input", {
                          attrs: { no: "dock", maxlength: 32 },
                          model: {
                            value: _vm.price.dock,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "dock", $$v)
                            },
                            expression: "price.dock"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.DestinationDock") } },
                      [
                        _c("el-input", {
                          attrs: { no: "destinationDock", maxlength: 32 },
                          model: {
                            value: _vm.price.destinationDock,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "destinationDock", $$v)
                            },
                            expression: "price.destinationDock"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.DepartureDay") } },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "isFrequency",
                            disabled: true,
                            value: _vm.isFrequency
                          }
                        })
                      ],
                      1
                    ),
                    _c("el-checkbox", {
                      staticStyle: { "margin-right": "12px" },
                      attrs: { no: "frequency1", label: 1 },
                      model: {
                        value: _vm.price.frequency1,
                        callback: function($$v) {
                          _vm.$set(_vm.price, "frequency1", $$v)
                        },
                        expression: "price.frequency1"
                      }
                    }),
                    _c("el-checkbox", {
                      staticStyle: { "margin-right": "12px" },
                      attrs: { no: "frequency2", label: 2 },
                      model: {
                        value: _vm.price.frequency2,
                        callback: function($$v) {
                          _vm.$set(_vm.price, "frequency2", $$v)
                        },
                        expression: "price.frequency2"
                      }
                    }),
                    _c("el-checkbox", {
                      staticStyle: { "margin-right": "12px" },
                      attrs: { no: "frequency3", label: 3 },
                      model: {
                        value: _vm.price.frequency3,
                        callback: function($$v) {
                          _vm.$set(_vm.price, "frequency3", $$v)
                        },
                        expression: "price.frequency3"
                      }
                    }),
                    _c("el-checkbox", {
                      staticStyle: { "margin-right": "12px" },
                      attrs: { no: "frequency4", label: 4 },
                      model: {
                        value: _vm.price.frequency4,
                        callback: function($$v) {
                          _vm.$set(_vm.price, "frequency4", $$v)
                        },
                        expression: "price.frequency4"
                      }
                    }),
                    _c("el-checkbox", {
                      staticStyle: { "margin-right": "12px" },
                      attrs: { no: "frequency5", label: 5 },
                      model: {
                        value: _vm.price.frequency5,
                        callback: function($$v) {
                          _vm.$set(_vm.price, "frequency5", $$v)
                        },
                        expression: "price.frequency5"
                      }
                    }),
                    _c("el-checkbox", {
                      staticStyle: { "margin-right": "12px" },
                      attrs: { no: "frequency6", label: 6 },
                      model: {
                        value: _vm.price.frequency6,
                        callback: function($$v) {
                          _vm.$set(_vm.price, "frequency6", $$v)
                        },
                        expression: "price.frequency6"
                      }
                    }),
                    _c("el-checkbox", {
                      staticStyle: { "margin-right": "12px" },
                      attrs: { no: "frequency7", label: 7 },
                      model: {
                        value: _vm.price.frequency7,
                        callback: function($$v) {
                          _vm.$set(_vm.price, "frequency7", $$v)
                        },
                        expression: "price.frequency7"
                      }
                    }),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.ClosingDay") } },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "closingDay",
                            disabled: true,
                            value: _vm.price.closingDay
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-checkbox-group",
                      {
                        attrs: { no: "closingDay" },
                        model: {
                          value: _vm.closingDay,
                          callback: function($$v) {
                            _vm.closingDay = $$v
                          },
                          expression: "closingDay"
                        }
                      },
                      _vm._l(_vm.frequencys, function(code) {
                        return _c(
                          "el-col",
                          { key: code, staticStyle: { width: "14%" } },
                          [_c("el-checkbox", { attrs: { label: code } })],
                          1
                        )
                      }),
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "days",
                        attrs: {
                          required: true,
                          label: _vm.$t("Pricing.DaysUnitSea")
                        }
                      },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "100%" },
                          attrs: { no: "days", min: 0, controls: false },
                          model: {
                            value: _vm.price.days,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "days", $$v)
                            },
                            expression: "price.days"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "freeTime",
                        attrs: {
                          required: _vm.isHc ? true : false,
                          label: _vm.$t("Pricing.FreeTime")
                        }
                      },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "freeTime",
                            precision: 0,
                            controls: false,
                            min: 0,
                            max: 999999999
                          },
                          model: {
                            value: _vm.price.freeTime,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "freeTime", $$v)
                            },
                            expression: "price.freeTime"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Currency") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "currency",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Currency,
                            clearable: false,
                            "default-value": _vm.price.currency
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.currency = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.EqType") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "eqType",
                            "select-type":
                              _vm.selectTypeNames.basic_data_EQType,
                            "tag-name": "code",
                            clearable: false,
                            "default-value": _vm.price.eqType
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.eqType = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "20'" } },
                      [
                        _c("numeric-stepper", {
                          ref: "cost20",
                          attrs: {
                            no: "cost20",
                            "show-tact": false,
                            "show-value": _vm.price.cost20
                          },
                          on: {
                            onChangeValue: function(p) {
                              _vm.price.cost20 = p
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "40'" } },
                      [
                        _c("numeric-stepper", {
                          ref: "cost40",
                          attrs: {
                            no: "cost40",
                            "show-tact": false,
                            "show-value": _vm.price.cost40
                          },
                          on: {
                            onChangeValue: function(p) {
                              _vm.price.cost40 = p
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "40HC'" } },
                      [
                        _c("numeric-stepper", {
                          ref: "costhc",
                          attrs: {
                            no: "costhc",
                            "show-tact": false,
                            "show-value": _vm.price.costhc
                          },
                          on: {
                            onChangeValue: function(p) {
                              _vm.price.costhc = p
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "20'NOR" } },
                      [
                        _c("numeric-stepper", {
                          ref: "cost20nor",
                          attrs: {
                            no: "cost20nor",
                            "show-tact": false,
                            "show-value": _vm.price.cost20nor
                          },
                          on: {
                            onChangeValue: function(p) {
                              _vm.price.cost20nor = p
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "40'NOR" } },
                      [
                        _c("numeric-stepper", {
                          ref: "cost40nor",
                          attrs: {
                            no: "cost40nor",
                            "show-tact": false,
                            "show-value": _vm.price.cost40nor
                          },
                          on: {
                            onChangeValue: function(p) {
                              _vm.price.cost40nor = p
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "45'" } },
                      [
                        _c("numeric-stepper", {
                          ref: "cost45",
                          attrs: {
                            no: "cost45",
                            "show-tact": false,
                            "show-value": _vm.price.cost45
                          },
                          on: {
                            onChangeValue: function(p) {
                              _vm.price.cost45 = p
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.priceNature") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "priceNature",
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_PriceConstant$PRICE_NATURE,
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.priceNature
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.priceNature = p.value
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.CabinNature") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "share",
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_PriceConstant$CABIN_NATURE,
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.share
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.share = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.SaleState") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "saleState",
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_SpecialPriceSaleState$SALE_STATE_TYPES,
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.saleState,
                            clearable: false
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.saleState = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.PriceState") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "priceState",
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_PriceConstant$PRICE_STATE,
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.priceState,
                            clearable: false
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.priceState = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm.price.priceState === 2
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Pricing.PriceState_Reject")
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-checkbox", {
                                  staticStyle: { "margin-right": "8px" },
                                  attrs: { no: "reject20", label: "20'" },
                                  model: {
                                    value: _vm.price.reject20,
                                    callback: function($$v) {
                                      _vm.$set(_vm.price, "reject20", $$v)
                                    },
                                    expression: "price.reject20"
                                  }
                                }),
                                _c("el-checkbox", {
                                  staticStyle: { "margin-right": "8px" },
                                  attrs: { no: "reject40", label: "40'" },
                                  model: {
                                    value: _vm.price.reject40,
                                    callback: function($$v) {
                                      _vm.$set(_vm.price, "reject40", $$v)
                                    },
                                    expression: "price.reject40"
                                  }
                                }),
                                _c("el-checkbox", {
                                  staticStyle: { "margin-right": "8px" },
                                  attrs: { no: "rejectHC", label: "40'HC" },
                                  model: {
                                    value: _vm.price.rejectHC,
                                    callback: function($$v) {
                                      _vm.$set(_vm.price, "rejectHC", $$v)
                                    },
                                    expression: "price.rejectHC"
                                  }
                                }),
                                _c("el-checkbox", {
                                  staticStyle: { "margin-right": "8px" },
                                  attrs: { no: "reject45", label: "45'" },
                                  model: {
                                    value: _vm.price.reject45,
                                    callback: function($$v) {
                                      _vm.$set(_vm.price, "reject45", $$v)
                                    },
                                    expression: "price.reject45"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.CargoType") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "cargoType",
                            filterable: "",
                            clearable: false,
                            "select-type":
                              _vm.selectTypeNames.basic_data_CargoType,
                            "default-value": _vm.price.cargoType
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.cargoType = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Commodity") } },
                      [
                        _c("el-input", {
                          attrs: { no: "commodity", type: "textarea" },
                          model: {
                            value: _vm.price.commodity,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "commodity", $$v)
                            },
                            expression: "price.commodity"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.ServiceMode") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "serviceMode",
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_PriceConstant$SERVICE_MODES,
                            placeholder: _vm.$t(
                              "Price.EuropeAndAmericaLinesDedicated"
                            ),
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.serviceMode,
                            clearable: false
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.serviceMode = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.ServiceCode") } },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "serviceCode",
                            placeholder: _vm.$t(
                              "Price.EuropeAndAmericaLinesDedicated"
                            ),
                            maxlength: 255
                          },
                          model: {
                            value: _vm.price.serviceCode,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "serviceCode", $$v)
                            },
                            expression: "price.serviceCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.PriceTrend") } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            staticStyle: {
                              display: "flex",
                              "margin-top": "3px"
                            },
                            attrs: { no: "trend" },
                            model: {
                              value: _vm.price.trend,
                              callback: function($$v) {
                                _vm.$set(_vm.price, "trend", $$v)
                              },
                              expression: "price.trend"
                            }
                          },
                          [
                            _c(
                              "el-radio",
                              { attrs: { no: "rise", label: 1 } },
                              [_vm._v(_vm._s(_vm.$t("Pricing.Rise")))]
                            ),
                            _c(
                              "el-radio",
                              { attrs: { no: "fair", label: 0 } },
                              [_vm._v(_vm._s(_vm.$t("Pricing.Fair")))]
                            ),
                            _c(
                              "el-radio",
                              { attrs: { no: "fall", label: -1 } },
                              [_vm._v(_vm._s(_vm.$t("Pricing.Fall")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "etd",
                        attrs: {
                          required:
                            _vm.isHc ||
                            (!_vm.isHc &&
                              _vm.price &&
                              _vm.price.freightType === 1)
                              ? true
                              : false,
                          label: _vm.$t("Pricing.ECommerceEtd")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticClass: "departure-date-picker",
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "etd",
                                type: "date",
                                "value-format": "yyyy-MM-dd"
                              },
                              model: {
                                value: _vm.price.etd,
                                callback: function($$v) {
                                  _vm.$set(_vm.price, "etd", $$v)
                                },
                                expression: "price.etd"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.ECommerceEta") } },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "eta",
                                type: "date",
                                "value-format": "yyyy-MM-dd"
                              },
                              model: {
                                value: _vm.price.eta,
                                callback: function($$v) {
                                  _vm.$set(_vm.price, "eta", $$v)
                                },
                                expression: "price.eta"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "beginDate",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.BeginDate")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "beginDate",
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                "picker-options": {
                                  disabledDate: function(time) {
                                    return (
                                      _vm.price.endDate &&
                                      time.getTime() >=
                                        new Date(
                                          _vm.price.endDate.length <= 10
                                            ? _vm.price.endDate + " 00:00:00"
                                            : _vm.price.endDate
                                        ).getTime()
                                    )
                                  }
                                },
                                clearable: ""
                              },
                              model: {
                                value: _vm.price.beginDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.price, "beginDate", $$v)
                                },
                                expression: "price.beginDate"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "endDate",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.EndDate")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "endDate",
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                "picker-options": {
                                  disabledDate: function(time) {
                                    return (
                                      _vm.price.beginDate &&
                                      time.getTime() <=
                                        new Date(
                                          _vm.price.beginDate.length <= 10
                                            ? _vm.price.beginDate + " 00:00:00"
                                            : _vm.price.beginDate
                                        ).getTime()
                                    )
                                  }
                                },
                                clearable: ""
                              },
                              model: {
                                value: _vm.price.endDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.price, "endDate", $$v)
                                },
                                expression: "price.endDate"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.EffectiveDateType") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "dateTypeEffective",
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_PriceFclDataType$PRC_DATE_TYPE,
                            "show-custom-label-in-option": true,
                            clearable: false,
                            "default-value": _vm.price.dateTypeEffective
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.dateTypeEffective = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("Pricing.ExpirationDateType") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "dateTypeExpiration",
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_PriceFclDataType$PRC_DATE_TYPE,
                            "show-custom-label-in-option": true,
                            clearable: false,
                            "default-value": _vm.price.dateTypeExpiration
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.dateTypeExpiration = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Pricing.ReceivingInstructions")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "receivingInstructions",
                            type: "textarea"
                          },
                          model: {
                            value: _vm.price.receivingInstructions,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "receivingInstructions", $$v)
                            },
                            expression: "price.receivingInstructions"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Remarks") } },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { "min-height": "80px" },
                          attrs: {
                            no: "remarks",
                            "text-chars": 0,
                            "warning-count": -1
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Remarks"),
                                _vm.price.remarks,
                                function(val) {
                                  _vm.price.remarks = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.price.remarks,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "remarks", $$v)
                            },
                            expression: "price.remarks"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "modal-append-to-body": false,
            "append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "198px" },
            attrs: {
              no: "advanceTextDialog",
              disabled: _vm.readonly,
              required: false,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.readonly,
                      expression: "!readonly"
                    }
                  ],
                  attrs: { no: "finishAdvanceText", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "close" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }